let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("agXE2")).then(() => parcelRequire('e2qmK'));